import { useCallback } from 'react';
import { useRecoilState } from 'recoil';
import { authState } from './authState';
import { apiClient } from '../api/client';
import { queryClient } from '../queryClient';
import { loginErrorMessage } from './loginErrorMessage';

const useAuth = () => {
  const [auth, setAuth] = useRecoilState(authState);

  const loggedIn = auth.isAuthenticated;

  const login = useCallback(
    async ({ id, password }) => {
      try {
        const response = await apiClient.post('/auth/login', {
          username: id,
          password,
        });

        const data = response?.data?.data;
        const isPasswordChangeRequired = Boolean(
          data?.isPasswordChangeRequired,
        );

        // 이전 계정의 조회 결과(이름·예약·출석 QR)가 남으면 다음 계정에게 보인다
        queryClient.clear();
        // 쿠키는 서버가 Set-Cookie로 심어줌. 프론트는 상태만 갱신.
        setAuth({ isAuthenticated: true });

        return {
          isPasswordChangeRequired,
          message: response?.data?.message,
        };
      } catch (error) {
        // 비밀번호 오류·요청 제한·서버·네트워크 문제를 구분해 안내한다.
        // 서버 원문은 학생에게 그대로 보여주지 않는다.
        throw new Error(loginErrorMessage(error));
      }
    },
    [setAuth],
  );

  const logout = useCallback(async () => {
    try {
      // 망이 느릴 때 15초를 기다리게 하지 않는다. 실패해도 finally 가 정리한다.
      await apiClient.post('/auth/logout', null, { timeout: 5000 });
    } finally {
      // 요청이 실패해도 화면 상태와 계정 캐시는 정리한다.
      // 서버 쿠키가 남아 있으면 다음 부팅 복원에서 다시 로그인 상태가 된다.
      setAuth({ isAuthenticated: false });
      queryClient.clear();
    }
  }, [setAuth]);

  return { ...auth, loggedIn, login, logout };
};

export default useAuth;
